/** 사업자 정보 — 전자상거래법상 표시 사항. */
export interface CompanyInfo {
  readonly companyName: string;
  readonly representativeName: string;
  readonly address: string;
  readonly businessRegistrationNumber: string;
  readonly mailOrderSalesRegistrationNumber: string;
  readonly email: string;
  readonly phone: string;
  readonly consultationHours: string;
  readonly bankAccount: string;
}

/**
 * 사업자 정보의 단일 원천 — 값은 회사가 제공한 그대로다.
 * web 푸터·회사 소개(`apps/web/src/shared/config/company.ts` 가 표시 줄로 옮긴다)와 api 견적 발행 설정(발행본 공급자 칸 —
 * 연락처는 전화 · 이메일)이 같은 값을 쓴다. 이미 발행된 견적은 발행 때의 사본을 들고 있어 여기를 고쳐도 바뀌지 않는다.
 */
export const COMPANY_INFO: CompanyInfo = {
  companyName: '주식회사 슈퍼스트럭처',
  representativeName: '강진혁',
  address: '충청남도 천안시 동남구 다가말4길 48, 2층 202호',
  businessRegistrationNumber: '720-81-03279',
  mailOrderSalesRegistrationNumber: '제2024-충남천안-2252호',
  email: 'super@superst.kr',
  phone: '070-8098-9481',
  consultationHours: '평일 09:00 ~ 18:00 (점심시간 12:00 ~ 13:00)',
  bankAccount: '하나은행 176-910047-46904 (주)슈퍼스트럭처',
};
